"use strict";

/* Restore access to the editorial MP4 already embedded in fallback product cards. */
(() => {
  document.querySelectorAll("[data-product-card]").forEach((card) => {
    const row = card.querySelector(".thumb-row");
    const video = card.querySelector(".product-main-video");
    if (!row || !video || row.querySelector('[data-kind="video"]')) return;

    const source = video.querySelector("source");
    const src = String(source?.getAttribute("src") || video.getAttribute("src") || "").trim();
    if (!src) return;

    const button = document.createElement("button");
    button.type = "button";
    button.className = "video-thumb";
    button.dataset.kind = "video";
    button.dataset.video = src;
    button.setAttribute("aria-label", "Ver vídeo del producto");

    const label = document.createElement("span");
    label.textContent = "Video";
    button.appendChild(label);
    row.appendChild(button);
  });
})();

/* Swap the real rendered media source when a product-card thumbnail is pressed. */
(() => {
  document.addEventListener("click", (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const thumb = target?.closest('.products [data-product-card] .thumb-row button[data-kind]');
    if (!thumb) return;

    const card = thumb.closest("[data-product-card]");
    if (!card) return;

    const image = card.querySelector(".product-main-image");
    const video = card.querySelector(".product-main-video");
    const kind = String(thumb.dataset.kind || "").trim().toLowerCase();

    if (kind === "image") {
      const src = String(thumb.dataset.image || "").trim();
      if (!image || !src) return;

      event.preventDefault();
      if (video) {
        try { video.pause(); } catch (_error) {}
        video.hidden = true;
      }

      image.hidden = false;
      image.removeAttribute("srcset");
      image.removeAttribute("sizes");
      image.setAttribute("src", src);
      image.src = src;
    } else if (kind === "video") {
      const src = String(thumb.dataset.video || "").trim();
      if (!video || !src) return;

      event.preventDefault();
      if (image) image.hidden = true;

      document.querySelectorAll(".product-main-video").forEach((item) => {
        if (item !== video) {
          try { item.pause(); } catch (_error) {}
        }
      });

      const source = video.querySelector("source");
      if (source) {
        if (source.getAttribute("src") !== src) {
          source.setAttribute("src", src);
          video.load();
        }
      } else if (video.getAttribute("src") !== src) {
        video.setAttribute("src", src);
        video.load();
      }

      video.hidden = false;
      try {
        video.currentTime = 0;
        const playback = video.play();
        if (playback && typeof playback.catch === "function") playback.catch(() => {});
      } catch (_error) {}
    } else {
      return;
    }

    card.querySelectorAll(".thumb-row button[data-kind]").forEach((item) => {
      const active = item === thumb;
      item.classList.toggle("active", active);
      item.setAttribute("aria-pressed", String(active));
    });
  }, true);
})();
